import React from 'react'
import BottomHeader from './BottomHeader'
import TopHeader from './TopHeader'

function Header() {
  return (
    <div>
        <TopHeader />
        <div className='mt-8 max-md:mt-4'></div>
        <BottomHeader />
    </div>
  )
}

export default Header